import { DrillField } from '@/types'
import { randElement, randInt } from '@/common'
import { Note, Chord } from 'tonal'

interface DropVoicingParams {
	Chords: Array<'maj7' | 'm7' | '7' | 'maj6' | 'm6' | 'm7b5'>
	Inversions: Array<'Root' | '1st' | '2nd' | '3d'>
	Voicings: Array<'Drop 2' | 'Drop 3' | 'Drop 2+3' | 'Drop 2+4'>
	Strings: Array<'E' | 'A' | 'D'>
}

const chords = ['maj7', 'm7', '7', 'maj6', 'm6', 'm7b5']
const inversions = ['Root', '1st', '2nd', '3d']
const voicings = ['Drop 2', 'Drop 3', 'Drop 2+3', 'Drop 2+4']

const orders = [
	['0231', '0312', '0132', '0213'],
	['1302', '1023', '1203', '1320'],
	['2013', '2130', '2310', '2031'],
	['3120', '3201', '3021', '3102']
]
const bases = [
	['2nd', '3d', '3d', 'Root'],
	['3d', 'Root', 'Root', '1st'],
	['Root', '1st', '1st', '2nd'],
	['1st', '2nd', '2nd', '3d']
];

(DropVoicings as any).params = [
	{ title: 'Chords', options: chords },
	{ title: 'Inversions', options: inversions },
	{ title: 'Voicings', options: voicings },
	{ title: 'Strings', options: ['E', 'A', 'D'] }
]

function DropVoicings(params: DropVoicingParams): DrillField[] {
	const note = Note.from({ step: randInt(0, 6), alt: randInt(-1, 1) })
	const chord = randElement(params.Chords)
	const inversion = inversions.indexOf(randElement(params.Inversions))
	const stringName = randElement(params.Strings)
	const voicing = stringName === 'D' ? 0 : voicings.indexOf(randElement(params.Voicings))
	const degrees = Chord.props(chord).intervals
	const notes = Chord.notes(note, chord)
	return [
		{
			label: 'Chord',
			value: note + chord
		},
		{
			label: 'Inversion',
			value: inversions[inversion]
		},
		{
			label: 'String',
			value: stringName
		},
		{
			label: 'Voicing',
			value: voicings[voicing]
		},
		{
			label: 'Degrees',
			value: orders[inversion][voicing].split('').map(i => degrees[i]).join(' '),
			hide: true
		},
		{
			label: 'Notes',
			value: orders[inversion][voicing].split('').map(i => notes[i]).join(' '),
			hide: true
		},
		{
			label: 'Base Inversion',
			value: bases[inversion][voicing],
			hide: true
		}
	]
}

export { DropVoicings }
